import { createGamificationConfigApi } from '@e-learning/core';
import {
  GamificationEngineSettings,
  LoadingModal,
  useGamificationConfig,
  useTheme,
  useTranslation,
} from '@e-learning/shared';
import { api } from '../../../api/client';

const gamificationConfigApi = createGamificationConfigApi(api);

export default function GamificationPage() {
  const theme = useTheme();
  const { t } = useTranslation();

  const {
    pointsValidityDays,
    setPointsValidityDays,
    loading,
    saving,
    error,
    save,
  } = useGamificationConfig(gamificationConfigApi);

  return (
    <div
      style={{
        width: '100%',
        padding: theme.spacing.lg,
        backgroundColor: theme.palette.background.default,
        minHeight: '100%',
        boxSizing: 'border-box',
      }}
    >
      <LoadingModal
        open={loading || saving}
        message={
          saving ? t('gamification.actions.saving') : t('gamification.loading')
        }
      />
      <header style={{ marginBottom: theme.spacing.xl }}>
        <h1
          style={{
            marginTop: 0,
            marginBottom: theme.spacing.xs,
            fontSize: theme.typography.fontSize['2xl'],
            fontWeight: theme.typography.fontWeight.semibold,
            color: theme.palette.text.primary,
          }}
        >
          {t('gamification.title')}
        </h1>
        <p
          style={{
            marginTop: 0,
            marginBottom: 0,
            fontSize: theme.typography.fontSize.base,
            color: theme.palette.text.secondary,
          }}
        >
          {t('gamification.subtitle')}
        </p>
      </header>

      <GamificationEngineSettings
        pointsValidityDays={pointsValidityDays}
        onPointsValidityDaysChange={setPointsValidityDays}
        onSave={() => {
          void save();
        }}
        loading={loading}
        saving={saving}
        errorKey={error}
      />
    </div>
  );
}
